import Siema from 'siema';

window.addEventListener('DOMContentLoaded', () => {
  const containers = document.querySelectorAll('[data-slideshow-container]');

  if (!containers.length) return;

  const slideshows = [];

  // Initialize each slideshow independently
  containers.forEach((container) => {
    const instance = new Siema({
      selector: container.querySelector('[data-slides]'),
      duration: parseInt(container.dataset.transitionDuration ?? 1000),
      easing: 'cubic-bezier(0.42, 0, 0.28, 0.86)',
      loop: true,
      draggable: false,
      perPage: parseInt(container.dataset.perPage ?? 1),
    });

    // Find controls for this specific slideshow
    // First check if controls are inside the container, then check siblings
    let nextButton = container.querySelector('[data-controls] [data-next-slide]');
    if (!nextButton) {
      // Check if controls are a sibling of the container
      const controls = container.parentElement?.querySelector('[data-controls]');
      if (controls) {
        nextButton = controls.querySelector('[data-next-slide]');
      }
    }

    const slideshow = {
      instance,
      container,
      dataset: container.dataset,
      interval: null,
      nextButton,
    };

    // Start autoplay if enabled
    const startAutoplay = (immediate = false) => {
      if (immediate) {
        slideshow.instance.next();
      }

      if (slideshow.dataset.autoplay) {
        // Clear existing interval if any
        if (slideshow.interval) {
          clearInterval(slideshow.interval);
        }

        slideshow.interval = setInterval(() => {
          slideshow.instance.next();
        }, parseInt(slideshow.dataset.duration ?? 20000));
      }
    };

    slideshow.startAutoplay = startAutoplay;
    slideshow.stopAutoplay = () => {
      if (slideshow.interval) {
        clearInterval(slideshow.interval);
        slideshow.interval = null;
      }
    };

    // Bind next button to this specific slideshow
    if (nextButton) {
      nextButton.addEventListener('click', () => {
        slideshow.stopAutoplay();
        slideshow.startAutoplay(true);
      });
    }

    // Start autoplay
    startAutoplay();

    slideshows.push(slideshow);
  });

  // Listen for tab exit and enter (blur/focus) - affects all slideshows independently
  window.addEventListener('blur', () => {
    slideshows.forEach((slideshow) => {
      slideshow.stopAutoplay();
    });
  });

  window.addEventListener('focus', () => {
    slideshows.forEach((slideshow) => {
      slideshow.startAutoplay();
    });
  });
});
